import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChange,
} from '@angular/core';
import {
  NavController,
  NavParams,
  App,
  ModalController,
  Events,
} from 'ionic-angular';
import { MatchmakingProvider } from '../../providers/matchmaking/matchmaking';
import { CurrentEventProvider } from '../../providers/current-event/current-event';
import { GlobalNotificationsProvider } from '../../providers/providers';
/**
 * Generated class for the MatchmakingPicksComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'matchmaking-picks',
  templateUrl: 'matchmaking-picks.html',
})
export class MatchmakingPicksComponent implements OnInit {
  picks: any[] = [];
  eventId: any;
  eventPin: number;
  page = 0;
  pageSize = 20;
  totalPages: number = 0;
  showInvisibeMsg: boolean = false;

  @Input('search')
  search: string = '';
  @Input('refresh')
  refresh;

  constructor(
    public events: Events,
    private app: App,
    private navCtrl: NavController,
    private navParams: NavParams,
    public modalCtrl: ModalController,
    private matchmakingProvider: MatchmakingProvider,
    private currentEventProvider: CurrentEventProvider,
    private globalNotificationsProvider: GlobalNotificationsProvider
  ) {
    events.subscribe('pick', () => {
      this.getPicks(this.eventId, this.search);
    });
  }

  ngOnChanges(changes: SimpleChange) {
    if (changes['refresh'] !== undefined || changes['search'] !== undefined) {
      if (this.eventId) {
        this.picks = [];
        this.getPicks(this.eventId, this.search);
      }
    }
  }
  ngOnInit(): void {
    this.currentEventProvider.currentEvent.subscribe(event => {
      this.getPicks(event.uuid, '');
      this.eventPin = event.pin;
      this.eventId = event.uuid;
    });
  }

  getPicks(eventId: string, query: string): void {
    this.page = 0;
    this.matchmakingProvider
      .searchEventPicksPaginated(eventId, query, this.page, this.pageSize)
      .subscribe((response: any) => {
        if (response.data.length > 0) {
          this.showInvisibeMsg = false;
          this.picks = response.data;
          this.totalPages = response.totalPages;
        } else {
          this.matchmakingProvider
            .checkUserStatus(this.eventPin)
            .subscribe(res => {
              this.showInvisibeMsg = res.visible ? false : true;
            });
        }
      });
  }
  viewMessages(userId: string): void {
    this.app.getRootNav().push('MessagePage', {
      userId: userId,
    });
  }

  viewProfile(userId: string): void {
    this.app.getRootNav().push('ProfilePage', {
      userId: userId,
      event: this.eventId,
    });
  }

  sendContactRequest(userId: string): void {
    let contactModal = this.modalCtrl.create('SendContactRequestPage', {
      userId: userId,
    });
    contactModal.onDidDismiss(data => {
      for (var i in this.picks) {
        if (this.picks[i].uuid == data) {
          this.picks[i].hasReceivedPendingRequest = true;
          break;
        }
      }
    });
    contactModal.present();
  }

  addNote(contact: any): void {
    this.app.getRootNav().push('NotePage', {
      user: contact,
    });
  }

  removePick(userId: string): void {
    this.matchmakingProvider.removePick(userId).subscribe(res => {
      let temp = this.picks;
      this.picks = temp.filter(pick => {
        return pick.uuid !== userId;
      });
      this.globalNotificationsProvider
        .getRemainingPicks(userId)
        .subscribe(res => {
          this.globalNotificationsProvider.setPicksRemainingCount(res.count);
        });
    });
  }

  doInfinite(infiniteScroll) {
    this.page++;
    setTimeout(() => {
      this.matchmakingProvider
        .searchEventPicksPaginated(
          this.eventId,
          this.search,
          this.page,
          this.pageSize
        )
        .subscribe(res => {
          this.picks.push(...res.data);
          this.totalPages = res.totalPages;
          infiniteScroll.complete();
        });
    }, 0);
  }

  shortTitle(element): number {
    let height = element.offsetHeight;
    return height;
  }
  profileOnEvent() {
    this.app.getRootNav().push('MatchmakingProfileSettingsPage', {});
  }
}



// WEBPACK FOOTER //
// ./src/components/matchmaking-picks/matchmaking-picks.ts